import { useNavigate } from 'react-router-dom';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { AppConfig } from '../../core/constants';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {'Copyright © '}
      {'2025-' + new Date().getFullYear()}
      &nbsp;
      <Link color="text.secondary" href="/">
        {AppConfig.appName}
      </Link>
      . &nbsp;
      {'Where heritage lives on.'}
    </Typography>
  );
}

export function Footer() {
  const navigate = useNavigate();
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: { xs: 2, sm: 4 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <div>
          <Link
            color="text.secondary"
            variant="body2"
            onClick={() => navigate('/privacy')}
          >
            Privacy Policy
          </Link>
          <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link
            color="text.secondary"
            variant="body2"
            onClick={() => navigate('/terms')}
          >
            Terms of Service
          </Link>
          <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link
            color="text.secondary"
            variant="body2"
            onClick={() => navigate('/cookie-policy')}
          >
            Cookies
          </Link>
          <Copyright />
        </div>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{ justifyContent: 'left', color: 'text.secondary' }}
        >
          <IconButton
            color="inherit"
            size="small"
            href={`${AppConfig.socials.linkedIn}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            sx={{ alignSelf: 'center' }}
          >
            <LinkedInIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href={`${AppConfig.socials.X}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X"
            sx={{ alignSelf: 'center' }}
          >
            <XIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href={`${AppConfig.socials.facebook}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            sx={{ alignSelf: 'center' }}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href={`${AppConfig.socials.instagram}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            sx={{ alignSelf: 'center' }}
          >
            <InstagramIcon />
          </IconButton>
        </Stack>
      </Box>
    </Container>
  );
}
